import { isNil } from "./isNil";
export var isNilOrEmpty = value => {
  return isNil(value) || value === "";
};
export var isNotNilOrEmpty = value => !isNilOrEmpty(value);